import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  Dropdown,
  InputGroup,
  Col,
  Row,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faBoltLightning,
  faHourglass,
  faCheck,
  faReply,
  faMinus,
  faTimes,
  faSearch,
  faClose,
  faCircleCheck,
  faCircleXmark,
  faMoneyBill
} from "@fortawesome/free-solid-svg-icons";
import { ActionHR } from "../../2.Commons/DropdownOption";
import { 
  updateCurrentPage, 
  getHRReviewPagination, 
  getHRReviewPageCount,
  ReviewedApplication,
  ApplicationNotification,
  searchHRReviewPagination,
  searchHRReviewPageCount,
  updateSearch
} from "../../3.Store/ReviewLeaveApplicationSlice";
import { getCompanies } from "../../3.Store/CompanySlice";
import { getSite } from "../../3.Store/SiteSlice";
import { getMedicalClaimByLeaveApplicationID } from '../../3.Store/MedicalClaimSlice';
import { ThreeDots } from 'react-loader-spinner';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import './ReviewLeave.css';
import Pagination from "../../2.Commons/Pagination";

const ReviewLeaveList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const leaveLists = useSelector(state => state.ReviewLeaveApplicationSlice.lists) || [];
  const currentPage = useSelector(state => state.ReviewLeaveApplicationSlice.currentPage);
  const totalPages = useSelector(state => state.ReviewLeaveApplicationSlice.totalPages);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [medicalClaimMap, setMedicalClaimMap] = useState({});
  const search = useSelector((state) => state.ReviewLeaveApplicationSlice.search);
  const {
    searchText,
    advancedLeave,
    annualLeave,
    hospitalizationLeave,
    maternityLeave,
    paternityLeave,
    otherLeave,
    sickLeave,
    specialLeave,
    unpaidLeave,
    company: selectedCompany,
    site: selectedSite
  } = search;
  const companyLists = useSelector(state => state.CompanySlice.companies) || [];
  const siteLists = useSelector(state => state.SiteSlice.sites) || [];
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const role = JSON.parse(localStorage.getItem("roles"));

  useEffect(() => {
    if (!role || !role.includes("HR-L-APPROVAL")) {  // Check required role 
      localStorage.clear(); 
      window.location.href = "/Login"; 
    }

    if (!isSearchActive) {
      setLoading(true);
      const isAnyFilterActive = search.advancedLeave || search.annualLeave || search.hospitalizationLeave ||
                             search.maternityLeave || search.paternityLeave || search.otherLeave || search.sickLeave ||
                             search.specialLeave || search.unpaidLeave || search.company || search.site;

      if (searchText === "" && isAnyFilterActive) {
        const entity = { ...search };
        dispatch(searchHRReviewPagination({ body: entity, currentPage }))
          .then(() => {
            dispatch(searchHRReviewPageCount(entity));
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else if (searchText !== "") {
        const entity = { ...search };
        dispatch(searchHRReviewPagination({ body: entity, currentPage }))
          .then(() => {
            dispatch(searchHRReviewPageCount(entity));
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        console.log(200)
        dispatch(getHRReviewPagination({ currentPage }))
          .then(() => {
            dispatch(getHRReviewPageCount());
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  }, [currentPage, isSearchActive]);

  // useEffect(() => {
  //   const fetchMedicalClaims = async () => {
  //     setLoading(true);
  //     const map = {};
  
  //     for (const employee of leaveLists) {
  //       if (employee.leave_type.id === "SI") {
  //         try {
  //           const result = await dispatch(
  //             getMedicalClaimByLeaveApplicationID({ id: employee.id }) // assuming employee.id is the leaveApplicationId
  //           ).unwrap();
  
  //           map[employee.id] = result;
  //         } catch (err) {
  //           map[employee.id] = false;
  //         }
  //       }
  //     }
  
  //     setMedicalClaimMap(map);
  //     setLoading(false);
  //   };
  
  //   if (leaveLists.length > 0) {
  //     fetchMedicalClaims();
  //   }
  // }, [leaveLists]);  

  useEffect(() => {
    dispatch(getCompanies());
    dispatch(getSite());
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearch = (e) => {
    const entity = {...search, searchText: e.target.value}
    dispatch(updateSearch(entity));
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearch();
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const entity = { ...search,  [name]: checked};
    console.log(entity)
    dispatch(updateSearch(entity));
  };

  const handleDropdownFilter = (e) => {
    const { name, value } = e.target;
    const entity = { ...search, [name]: value };
    dispatch(updateSearch(entity));
  };

  const handleBtnSearch = () => {
    setLoading(true);
    setMedicalClaimMap({});
    dispatch(updateCurrentPage(1)); // Set current page to 1
    const entity = { ...search };
    console.log(entity);
    const isAnyFilterActive = search.advancedLeave || search.annualLeave || search.hospitalizationLeave ||
                             search.maternityLeave || search.paternityLeave || search.otherLeave || search.sickLeave ||
                             search.specialLeave || search.unpaidLeave || search.company || search.site;

    // if ((searchText === "" && isAnyFilterActive) || searchText !== "") {
    if (searchText === "" && isAnyFilterActive) {
      setIsSearchActive(true);
      console.log(isSearchActive)
      dispatch(searchHRReviewPagination({ body:entity, currentPage:1 }))
        .then(() => {
          dispatch(searchHRReviewPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    else if (searchText !== "") {
      setIsSearchActive(true);
      console.log(isSearchActive)
      dispatch(searchHRReviewPagination({ body:entity, currentPage:1 }))
        .then(() => {
          dispatch(searchHRReviewPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    else {
      setIsSearchActive(false);
      console.log(isSearchActive)
      dispatch(getHRReviewPagination({ currentPage }))
        .then(() => {
          dispatch(getHRReviewPageCount());
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }      
  };

  const handleDropdownAction = (actionValue) => {

    if (selectedCheckboxes.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Please select at least one checkbox',
        confirmButtonText: 'OK'
      });
      return; // stop further execution
    };

    if (actionValue === "reviewedAction") {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          dispatch(ReviewedApplication(selectedCheckboxes))
            .unwrap()
            .then(() => {
              setLoading(false)
              Swal.fire("Leave Application Reviewed", "", "success", "OK");
              navigate(`/ReviewLeaveList`);
              if(searchText === ""){
                dispatch(getHRReviewPagination({ currentPage }))
                .then(() => {
                  dispatch(getHRReviewPageCount());
                  setLoading(false);
                })
                .catch(() => {
                  setLoading(false);
                });
              }
              else if (searchText !== ""){
                const entity = { ...search };
                console.log(entity);
                dispatch(searchHRReviewPagination({ body:entity, currentPage }))
                  .then(() => {
                    dispatch(searchHRReviewPageCount(entity));
                    setLoading(false);
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }
              setSelectedCheckboxes([]); // Clear checkboxes
            })
            .catch((err) => {
              Swal.fire("Error", err.response.data, "error", "OK");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
              'Cancelled',
              'Review cancelled',
              'error'
          );
        }
      });
    }
    else if (actionValue === "sendNotificationAction") {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Send Notification',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          dispatch(ApplicationNotification(selectedCheckboxes))
            .unwrap()
            .then(() => {
              setLoading(false);
              Swal.fire("Notification Sent", "", "success", "OK");
              navigate(`/ReviewLeaveList`);
              if(searchText === ""){
                dispatch(getHRReviewPagination({ currentPage }))
                .then(() => {
                  dispatch(getHRReviewPageCount());
                  setLoading(false);
                })
                .catch(() => {
                  setLoading(false);
                });
              }
              else if (searchText !== ""){
                const entity = { ...search };
                console.log(entity);
                dispatch(searchHRReviewPagination({ body:entity, currentPage }))
                  .then(() => {
                    dispatch(searchHRReviewPageCount(entity));
                    setLoading(false);
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }
              setSelectedCheckboxes([]); // Clear checkboxes
            })
            .catch((err) => {
              Swal.fire("Error", err.response.data, "error", "OK");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
              'Cancelled',
              'Send notification cancelled',
              'error'
          );
        }
      });
    }
  };

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleClickView = (leaveId) => {
    navigate(`/ReviewLeaveForm/${leaveId}`)
  };

  const handleClickViewMedicalClaim = (leaveApplicationId) => {
    navigate(`/HRReviewMedicalForm/leave/${leaveApplicationId}`)
  };

  const handleCheckChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedCheckboxes(prevState => [...prevState, id]);
    } else {
      setSelectedCheckboxes(prevState => prevState.filter(item => item !== id));
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      if (!isSearchActive) {
        dispatch(getHRReviewPageCount({ currentPage: currentPage - 1 }));
      }
      else {
        setLoading(true);
        const entity = { ...search };
        dispatch(searchHRReviewPagination({ currentPage: currentPage - 1, body:entity }))
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      if(!isSearchActive) {
        console.log("not search active");
        dispatch(getHRReviewPagination({ currentPage: currentPage + 1 }));
      }
      else {
        console.log("search active");
        setLoading(true);
        const entity = { ...search };
        dispatch(searchHRReviewPagination({ currentPage: currentPage + 1, body:entity }))
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  };

  const handlePageChange = (page) => {
    // setLoading(true);
    dispatch(updateCurrentPage(page));
    if(!isSearchActive) {
      setLoading(true);
      console.log("not search active");
      dispatch(getHRReviewPagination({ currentPage: page }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    else {
      console.log("search active");
      setLoading(true);
      const entity = { ...search };
      dispatch(searchHRReviewPagination({ currentPage: page, body:entity }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };  

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">HR Review Leave Applications</h1>
        <h1 className="MiniTitleHeader">List</h1>

        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <InputGroup className="mb-3">
          <Form.Control placeholder="Search Employee" name="searchText" value={searchText} onChange={handleSearch} onKeyPress={handleKeyPress} />
          <Button className="SearchIconBtn" onClick={handleBtnSearch}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>

        <Row className="mb-3">
          <Col md={6} sm={6} xs={12} className="mb-2 mb-md-0">
            <Form.Select name="company" value={selectedCompany} onChange={handleDropdownFilter}>
              <option value="">All Companies</option>
              {companyLists.map((c) => (
                <option key={c.id} value={c.id}>{c.description}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6} sm={6} xs={12}>
            <Form.Select name="site" value={selectedSite} onChange={handleDropdownFilter}>
              <option value="">All Sites</option>
              {siteLists.map((s) => (
                <option key={s.id} value={s.id}>{s.description}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <div className="FormLabel">
          <Form.Check inline type="checkbox" label="Annual Leave" name="annualLeave" checked={annualLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Advanced Leave" name="advancedLeave" checked={advancedLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Sick Leave" name="sickLeave" checked={sickLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Special Leave" name="specialLeave" checked={specialLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Other Leave" name="otherLeave" checked={otherLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Unpaid Leave" name="unpaidLeave" checked={unpaidLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Maternity Leave" name="maternityLeave" checked={maternityLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Paternity Leave" name="paternityLeave" checked={paternityLeave} onChange={handleCheckboxChange}/>
          <Form.Check inline type="checkbox" label="Hospitalization Leave" name="hospitalizationLeave" checked={hospitalizationLeave} onChange={handleCheckboxChange}/>
        </div>

        <Table className="mt-3 my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
          <thead>
            <tr>
              {isMobile ? (
                <>
                  <th style={{ width: "65px" }}>Leave Applications</th>
                  <th style={{ width: "5px" }} className="text-center align-middle">Status</th>
                  <th style={{ width: "5px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faEye} />
                  </th>
                  <th style={{ width: "5px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faBoltLightning} />
                  </th>
                </>
              ) : (
                <>
                  <th style={{ width: "150px" }}>Date Applied</th>
                  <th style={{ width: "300px" }}>Employee</th>
                  <th style={{ width: "150px" }}>Type</th>
                  <th style={{ width: "150px" }}>No. of Days Applying</th>
                  <th className="text-center align-middle" style={{ width: "80px" }}>Status</th>
                  <th className="text-center align-middle" style={{ width: "80px" }}>
                    <FontAwesomeIcon icon={faMoneyBill} title="Medical Claim" />
                  </th>
                  <th className="text-center align-middle" style={{ width: "50px" }}>
                    <FontAwesomeIcon icon={faEye} title="Review" />
                  </th>
                  <th className="text-center align-middle" style={{ width: "50px" }}>
                    <FontAwesomeIcon icon={faBoltLightning} title="Action" />
                  </th>
                </>
              )}
            </tr>
          </thead>
          {!loading && (
            <tbody>
              {leaveLists.length > 0 ? (
                leaveLists.map(employee => (
                  <tr key={employee.id} style={{ cursor: "pointer" }}>
                    {isMobile ? (
                      <>
                        <td onClick={() => handleClickView(employee.id)}>
                          <strong>{employee.employee.fullname}</strong>
                          <br />
                          <strong>{employee.leave_type.description} ({employee.number_of_days}D)</strong>
                          <br />
                          <strong>From: </strong>{moment(employee.from_date.date).format("YYYY-MM-DD")} ({employee.from_ampm})
                          <br />
                          <strong>To: </strong>{moment(employee.to_date.date).format("YYYY-MM-DD")} ({employee.to_ampm})
                          <br />
                          <span className="ellipsis2">{employee.reason_for_application}</span>
                        </td>
                        <td onClick={() => handleClickView(employee.id)} className="text-center align-middle">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{employee.status.description}</Tooltip>}
                          >
                            <span>
                              {employee.status.description == "Approved by Supervisor" && (
                                <FontAwesomeIcon icon={faCheck} color="#28A744" />
                              )}
                              {employee.status.description == "Rejected by Supervisor" && (
                                <FontAwesomeIcon icon={faTimes} color="#DC3545" />
                              )}
                              {employee.status.description == "Pending Approval" && (
                                <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                              )}
                              {employee.status.description == "Approved by HR" && (
                                <FontAwesomeIcon icon={faCircleCheck} color="#452e9e" />
                              )}
                              {employee.status.description == "Rejected by HR" && (
                                <FontAwesomeIcon icon={faCircleXmark} color="#452e9e" />
                              )}
                              {employee.status.description == "Leave Withdrawn by staff with Approval" && (
                                <FontAwesomeIcon icon={faReply} color="#17A2B8" />
                              )}
                              {employee.status.description == "Leave Withdrawn by staff (Pending Approval)" && (
                                <FontAwesomeIcon icon={faReply} color="#FFC107" />
                              )}
                              {employee.status.short_description == "REVERT" && (
                                <FontAwesomeIcon icon={faReply} color="#DC3545" />
                              )}
                            </span>
                          </OverlayTrigger>
                        </td>
                
                        <td onClick={() => handleClickView(employee.id)} className="text-center align-middle">
                          {employee.reviewed == -1 && (
                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                          )}
                          {employee.reviewed == 1 && (
                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                          )}
                        </td>
                        
                        <td className="text-center align-middle">
                          <Form.Check
                            type="checkbox"
                            id={`checkbox-${employee.id}`}
                            name={`checkbox-${employee.id}`}
                            onChange={(e) => handleCheckChange(e, employee.id)}
                            checked={selectedCheckboxes.includes(employee.id)}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <td onClick={() => handleClickView(employee?.id)}>{moment(employee?.created).format("YYYY-MM-DD")}</td>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.employee.fullname}</td> */}
                        <td onClick={() => handleClickView(employee?.id)}>
                          {employee?.employee?.fullname
                            .toLowerCase()
                            .split(' ')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ')}
                        </td>
                        <td onClick={() => handleClickView(employee.id)}>{employee?.leave_type?.description}</td>
                        <td onClick={() => handleClickView(employee.id)}>{employee?.number_of_days}</td>
                        <td className="text-center align-middle" onClick={() => handleClickView(employee?.id)}>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{employee?.status?.description}</Tooltip>}
                          >
                            <span>
                              {employee?.status?.description == "Approved by Supervisor" && (
                                <FontAwesomeIcon icon={faCheck} color="#28A744" />
                              )}
                              {employee?.status?.description == "Rejected by Supervisor" && (
                                <FontAwesomeIcon icon={faTimes} color="#DC3545" />
                              )}
                              {employee?.status?.description == "Pending Approval" && (
                                <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                              )}
                              {employee?.status?.description == "Approved by HR" && (
                                <FontAwesomeIcon icon={faCircleCheck} color="#452e9e" />
                              )}
                              {employee?.status?.description == "Rejected by HR" && (
                                <FontAwesomeIcon icon={faCircleXmark} color="#452e9e" />
                              )}
                              {employee?.status?.description == "Leave Withdrawn by staff with Approval" && (
                                <FontAwesomeIcon icon={faReply} color="#17A2B8" />
                              )}
                              {employee?.status?.description == "Leave Withdrawn by staff (Pending Approval)" && (
                                <FontAwesomeIcon icon={faReply} color="#FFC107" />
                              )}
                              {employee?.status?.short_description == "REVERT" && (
                                <FontAwesomeIcon icon={faReply} color="#DC3545" />
                              )}
                            </span>
                          </OverlayTrigger>
                        </td>

                        <td className="text-center align-middle">
                          {employee?.leave_type?.id === "SI" && employee?.medical_benefit && (
                            <FontAwesomeIcon icon={faMoneyBill} title="Medical Claim" onClick={() => handleClickViewMedicalClaim(employee.id)}/>
                          )}
                        </td>

                        {/* <td className="text-center align-middle">
                          {employee.leave_type.id === "SI" && medicalClaimMap[employee.id] && (
                            <FontAwesomeIcon
                              icon={faMoneyBill}
                              title="Medical Claim"
                              onClick={() => handleClickViewMedicalClaim(employee.id)}
                            />
                          )}
                        </td> */}
                
                        <td className="text-center align-middle" onClick={() => handleClickView(employee?.id)}>
                          {employee?.reviewed == -1 && (
                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                          )}
                          {employee?.reviewed == 1 && (
                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                          )}
                        </td>
                        
                        <td className="text-center align-middle">
                          <Form.Check
                            type="checkbox"
                            id={`checkbox-${employee?.id}`}
                            name={`checkbox-${employee?.id}`}
                            onChange={(e) => handleCheckChange(e, employee?.id)}
                            checked={selectedCheckboxes.includes(employee?.id)}
                          />
                        </td>
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No results found</td>
                </tr>
              )}
            </tbody>
          )}
        </Table>

        <div className="legend-pagination-row">
          <div className="legend-container" style={{ overflowX: 'auto' }}>
            <div className="legend-grid-two-rows">
              <span className="legend-item2">
                <FontAwesomeIcon icon={faHourglass} color="#FFC107" />&nbsp;Pending
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faMinus} color="#FFC107" />&nbsp;Deleted
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faCheck} color="#28A744" />&nbsp;Approved (Supervisor)
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faTimes} color="#DC3545" />&nbsp;Rejected (Supervisor)
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faCircleCheck} color="#452e9e" />&nbsp;Approved (HR)
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faCircleXmark} color="#452e9e" />&nbsp;Rejected (HR)
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#17A2B8" />&nbsp;Withdrawn
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#FFC107" />&nbsp;Withdrawning
              </span>
              <span className="legend-item2">
                {/* <FontAwesomeIcon icon={faReply} color="#FFC107" />&nbsp;Withdrawning */}
              </span>
              <span className="legend-item2">
                <FontAwesomeIcon icon={faReply} color="#DC3545" />&nbsp;Withdrawn Rejected
              </span>
            </div>
          </div>

          {/* Pagination Section */}
          <div
            style={{
              marginLeft: "auto",
              marginTop: isMobile ? "10px" : "0px"
            }}
          >
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        {/* <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        /> */}

        {/* <Table>
          <tbody>
            <tr>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                &nbsp;Pending
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faCheck} color="#28A744" />
                &nbsp;Approved (Supervisor)
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faCircleCheck} color="#452e9e" />
                &nbsp;Approved (HR)
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faReply} color="#17A2B8" />
                &nbsp;Withdrawn
              </td>
              <td className="FormLabel">

              </td>
            </tr>
            <tr>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                &nbsp;Deleted
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faTimes} color="#DC3545" />
                &nbsp;Rejected (Supervisor)
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faCircleXmark} color="#452e9e" />
                &nbsp;Rejected (HR)
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faReply} color="#FFC107" />
                &nbsp;Withdrawning
              </td>
              <td className="FormLabel">
                <FontAwesomeIcon icon={faReply} color="#DC3545" />
                &nbsp;Withdrawn Rejected
              </td>
            </tr>
          </tbody>
        </Table> */}

        <div className="d-flex justify-content-between my-2">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <Dropdown>
            <Dropdown.Toggle className="Button">Action</Dropdown.Toggle>
            <Dropdown.Menu>
              {ActionHR.map((action, index) => (
                <Dropdown.Item key={index} onClick={() => handleDropdownAction(action.value)}>
                  {action.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card>
    </div>
  );
};
export default ReviewLeaveList;
